import styled from "styled-components";

export const V3EmbedLinkToOriginal = styled.div`
    display: flex;
    align-items: center;

    > div {
        display: inline-flex;
        
        &:first-child {
            margin-right: 8px;
        }
    }
`;

export const V3EmbedFooterCTA = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;